import React from 'react';
import { ClockIcon } from 'lucide-react';
export const WaitingListModule = () => {
  return <div className="space-y-6" data-id="element-4136">
      <h1 className="text-2xl font-bold text-gray-800" data-id="element-4137">Waiting List</h1>
      <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-4138">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-4139">
          <ClockIcon className="h-8 w-8 text-blue-600" data-id="element-4140" />
        </div>
        <h2 className="text-xl font-medium text-gray-800 mb-2" data-id="element-4141">
          Waiting List Module
        </h2>
        <p className="text-gray-600 mb-6 max-w-md mx-auto" data-id="element-4142">
          This module will display customers waiting for availability with
          priority indicators and quick conversion buttons.
        </p>
      </div>
    </div>;
};